// ============================================================
// Mixin — filtros/busca/paginação de listas refletidos na URL
// ------------------------------------------------------------
// Mantém o estado de filtro no query string (deep-link + voltar/avançar).
// A view lê os defaults no created() com clinicaReadQuery() e escreve as
// mudanças com clinicaSyncQuery(patch). Watch em $route.query reage à
// navegação do browser.
// ============================================================
export default {
  methods: {
    /** Lê os filtros da URL sobre um objeto de defaults. */
    clinicaReadQuery(defaults = {}) {
      return { ...defaults, ...this.$route.query };
    },

    /**
     * Grava um patch de filtros na URL (replace, sem empilhar histórico).
     * Remove valores vazios / "todos" para manter a URL limpa.
     */
    clinicaSyncQuery(patch) {
      const query = { ...this.$route.query };
      Object.keys(patch).forEach(k => {
        const v = patch[k];
        if (v === "" || v == null || v === "todos" || v === "todas") {
          delete query[k];
        } else {
          query[k] = String(v);
        }
      });
      const changed =
        JSON.stringify(query) !== JSON.stringify(this.$route.query);
      if (changed) {
        // .catch evita o erro NavigationDuplicated do vue-router 3.
        this.$router.replace({ query }).catch(() => {});
      }
    }
  }
};
